import { useParams } from 'react-router-dom';
import EnhancedPetitionDetails from '../../components/petitions/PetitionDetails/EnhancedPetitionDetails';
import './EnhancedPetitionDetailsPage.scss';

const EnhancedPetitionDetailsPage = () => {
  const { id } = useParams();

  return (
    <div className="enhanced-petition-details-page">
      <div className="container">
        <EnhancedPetitionDetails petitionId={id} />
      </div>
    </div>
  );
};

export default EnhancedPetitionDetailsPage;